module.exports = __webpack_public_path__ + "images/vkb_bc_thumb_up.png?213ca4c591c15f45fccb8dd49c091d27";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vkb_bc_thumb_up.png
// module id = pVAg
// module chunks = 0